module.exports = __webpack_public_path__ + "static/img/AS.209bf6c0.png";